import headerAvatarUrl from "@assets/bioImg-45x45.webp";
import Header from "./Header";
import PersonIcon from "@mui/icons-material/Person";
import DataObjectIcon from "@mui/icons-material/DataObject";
import EmailIcon from "@mui/icons-material/Email";
import WebIcon from "@mui/icons-material/Web";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import GroupAddIcon from "@mui/icons-material/GroupAdd";

export default {
  component: Header,
};

export const Primary = {
  render: (args) => <Header {...args} />,
  args: {
    headerAvatar: {
      src: headerAvatarUrl?.src,
      alt: "Jace Edwards coding portfolio",
    },
    navItems: [
      {
        title: "About",
        icon: <PersonIcon />,
      },
      {
        title: "Projects",
        icon: <WebIcon />,
      },
      {
        title: "Technologies",
        icon: <DataObjectIcon />,
      },
      {
        title: "Certifications",
        icon: <WorkspacePremiumIcon />,
      },
      {
        title: "Connect",
        icon: <GroupAddIcon />,
      },
      {
        title: "Contact",
        icon: <EmailIcon />,
      },
    ],
  },
};
